<template>
  <div :style="!isUserThalesAdmin() ? 'padding: 2rem;' :'' ">
    <h1>Document Reference [{{flux}}] </h1>
    <b-row>
      <b-col md="3">
        <b-form-group horizontal label="Filtrer" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type de recherche" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Effacer</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2" style="display: flex; align-items: flex-end; margin-bottom: 10px">
        <h6 style="margin: 0 10px 0 0;">Voir les références cloturées</h6>
        <input 
          v-model="seeClosed" 
          type="checkbox" 
          style="width: 20px; height: 20px"
          @change="onSeeClosedChanged"
        >
      </b-col>
      <b-col md="2" style="display: flex; align-items: flex-end; margin-bottom: 10px">
        <h6 style="margin: 0 10px 0 0;">Voir les références bloquées</h6>
        <input 
          v-model="seeBlocked"
          type="checkbox" 
          style="width: 20px; height: 20px"
          @change="onSeeBlockedChanged"
        >
      </b-col>
      <b-col offset-md="2" md="3" style="display: flex; align-items: flex-end;">
        <b-input-group-append>
          <b-btn :disabled="exporting" @click="downloadExcel">
            <span v-if="exporting">
              <i class="fa fa-spinner fa-spin fa fa-fw" />
              Export...
            </span>
            <span v-else>
              Exporter
            </span>
          </b-btn>
          
        </b-input-group-append>
      </b-col>
    </b-row><br>
    <b-table
      hover
      borderless
      no-border-collapse
      no-sort-reset
      ref="scanslist"
      :busy.sync="isBusy"
      :small="small"
      :dark="dark"
      :fixed="fixed"
      :foot-clone="false"
      :items="getDocsAsync"
      :filter="filter"
      @filtered="onFiltered"
      filter-debounce="400"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      @row-clicked="goToTracking"
      class="documents-list">
        <template v-slot:cell(document_code)="row">
          <div class="reference-slot">
            <div>{{ chunk(row.item.document_code, 3) }}</div>
            <b-badge 
              style="height: fit-content; padding: 7px 10px 7px 10px;"
              v-if="row.item.reference_closed"
              pill variant="dark"
            >
              Cloturée
            </b-badge>
             <b-badge 
              style="height: fit-content; padding: 7px 10px 7px 10px;"
              v-if="row.item.reference_blocked"
              pill variant="dark"
            >
              Bloquée
            </b-badge>
             <div v-if="row.item.document_sdcd" class="sdcd-pill"></div>
          </div>
        </template>
        <template v-slot:cell(document_created_at)="row">
          {{row.item.document_created_at | moment('DD/MM/YYYY HH:mm')}}
        </template>
        <template v-slot:cell(last_scan)="row">
          {{row.item.last_scan | moment('DD/MM/YYYY HH:mm')}}
        </template>
        <template v-slot:cell(worksation_name)="row">
          {{ row.item.worksation_name }} 
          <strong v-if="!row.item.reference_closed">: {{row.item.current_leadtime}} h</strong>
        </template>
        <template v-slot:cell(lead_time)="row">
          <strong>{{row.item.total_lead_time}} h</strong>
        </template>
      <div slot="table-busy" class="text-center text-danger my-2">
        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" align="center" v-model="currentPage" />
      </b-col>
    </b-row>
  </div>
</template>
<script>

import server from '../../api/server.vue'
import moment from 'moment'
import { saveAs } from 'file-saver'

const items = [
  { isActive: true, loading: 'Loading' },
]

export default {
  name: 'ReferenceDocumentLoop',
  data() {
    return {
        flux: null,
        filter: null,
        currentPage: 1,
        totalRows: 1,
        perPage: 50,
        small: false,
        fixed: false,
        dark: false,
        items: [],
        isBusy: false,
        exporting: false,
        seeClosed: false,
        seeBlocked: false,
        actualCtx: {},
        fields: [
          { key: 'document_code', label: 'Référence', sortable: true, class: 'reference-document' },
          { key: 'worksation_name', label: 'Station', sortable: true },
          { key: 'lead_time', label: 'Lead Time', sortable: true },
          { key: 'last_scan', label: 'Dernier scan', sortable: true },
        ],
      };
  },
  beforeRouteUpdate(to, from, next) {
    this.flux = to.params.flux
    this.items = []
    this.$refs.scanslist.refresh()
    next()
  },
  methods: {
    downloadExcel () {
      this.exporting = true
      this.$toasted.success('Chargement des données, cela peut prendre quelques secondes...')
      const flux = (this.flux.replace(/ /g,"_")).toLowerCase()
      server.getScanDocumentExcel(flux).then((response) => {
        let contentDispo = response.headers['content-disposition'].split('filename=')
        contentDispo = contentDispo[1].substring(0, contentDispo[1].length-1)
        saveAs(response.data, contentDispo)
        this.exporting = false
        this.$toasted.success('Données exportées.')
      }).catch((e) => {
        this.exporting = false
        this.$toasted.error('Erreur...')
        console.error(e)
      })
    },
    goToTracking (row ) {
      this.goTo('/tracking_order/' + row.document_code)
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onSeeClosedChanged () {
      this.getDocsAsync(this.actualCtx).then((res) => console.log(JSON.stringify(res, null, 2)))
      this.$refs.scanslist.refresh()
    },
    onSeeBlockedChanged () {
      this.getDocsAsync(this.actualCtx).then((res) => console.log(JSON.stringify(res, null, 2)))
      this.$refs.scanslist.refresh()
    },
    getDocsAsync (ctx) {
      if(this.seeClosed)
        ctx = {...ctx, useClosed: true}
      if(this.seeBlocked)
        ctx = {...ctx, useBlocked: true}
      this.actualCtx = ctx;
      const today = Date.now()
      const flux = (this.flux.replace(/ /g,"_")).toLowerCase()
      return server.getScanFromLoopAsync(flux, ctx).then((result) => {
        this.items.length = 0
        var scansList = result.data.scans
        this.totalRows = result.data.totalScans
        for (var i = 0; i < scansList.length; i++){
          var obj = {}
          obj.reference_closed = scansList[i].reference_closed
          obj.reference_blocked = scansList[i].document_base.blocked
          obj.document_code = scansList[i].document_base.code
          obj.document_sdcd = scansList[i].document_base.sdcd
          obj.worksation_name = scansList[i].workstation.name
          obj.last_scan = scansList[i].created_at
          obj.lead_time = scansList[i].sum_lead_time_since_start
          obj.workstation_max_leadtime = scansList[i].workstation.max_lead_time
          var dateLastScan = new Date(obj.last_scan);
          obj.current_leadtime = parseInt(scansList[i].current_leadtime / 3600)
          obj.total_lead_time = parseInt(scansList[i].total_lead_time / 3600)
          obj['_cellVariants'] = {}
          obj['_cellVariants']['lead_time'] = obj.workstation_max_leadtime > obj.current_leadtime ? '' : 'danger'
          this.items.push(obj)
        }
        this.isBusy = false
        return this.items
      })
      .catch((error) => {
        console.log(error)
        this.$toasted.error('Erreur durant la récupération des documents...')
      })
    },
  },
  mounted: function () {
    this.flux = this.$route.params.flux
  }
};
</script>
<style>
  .documents-list {
    font-family: 'Montserrat';
    color: #242424;
  }
  .documents-list tbody .reference-document {
    color: #ffffff;
    background-color: var(--a-dark-blue);
  }
  .documents-list tbody .reference-document .reference-slot {
    width: 100%;
    padding: 0 10% 0 10% 0; 
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .documents-list.table.b-table.b-table-no-border-collapse  {
    border-spacing: 0 0.5rem;
  }

  .documents-list.table.b-table.b-table-no-border-collapse tbody td {
    border-right: 2px solid white;
  }

  .documents-list thead {
    background-color: var(--a-dark-grey);
  }

  .documents-list tbody tr {
    background-color: var(--a-light-grey);
    cursor: pointer;
  }

  /* .documents-list .table-danger {
    background-color: var(--red);
    color: white;
  } */
  .documents-list.table-hover tbody tr:hover {
    background-color: var(--a-dark-grey);
  }
</style>



// WEBPACK FOOTER //
// src/components/document/ReferenceDocumentLoop.vue